import { eventRefereeConstants } from '../_constants';
import { eventRefereeService } from '../_services';

export const eventRefereeActions = {
  addReferee,
  removeReferee,
  referees,
  availableReferees,
};

function addReferee(id, refereeId) {
  return (dispatch) => {
    dispatch(request({ id, refereeId }));
    eventRefereeService.addReferee(id, refereeId).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };
  function request(data) {
    return { type: eventRefereeConstants.ADD_REFEREE_REQUEST, data };
  }
  function success(data) {
    return { type: eventRefereeConstants.ADD_REFEREE_SUCCESS, data };
  }
  function failure(error) {
    return { type: eventRefereeConstants.ADD_REFEREE_FAILURE, error };
  }
}

function removeReferee(id, refereeId) {
  return (dispatch) => {
    dispatch(request({ id, refereeId }));
    eventRefereeService.removeReferee(id, refereeId).then(
      (data) => {
        dispatch(success({ refereeId }));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };
  function request(data) {
    return { type: eventRefereeConstants.REMOVE_REFEREE_REQUEST, data };
  }
  function success(data) {
    return { type: eventRefereeConstants.REMOVE_REFEREE_SUCCESS, data };
  }
  function failure(error) {
    return { type: eventRefereeConstants.REMOVE_REFEREE_FAILURE, error };
  }
}

function referees(id) {
  return (dispatch) => {
    dispatch(request({ id }));
    eventRefereeService.referees(id).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };
  function request(data) {
    return { type: eventRefereeConstants.GET_REFEREES_REQUEST, data };
  }
  function success(data) {
    return { type: eventRefereeConstants.GET_REFEREES_SUCCESS, data };
  }
  function failure(error) {
    return { type: eventRefereeConstants.GET_REFEREES_FAILURE, error };
  }
}

function availableReferees(id) {
  return (dispatch) => {
    dispatch(request());
    eventRefereeService.availableReferees(id).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };
  function request(data) {
    return { type: eventRefereeConstants.GET_AVAILABLE_REFEREES_REQUEST, data };
  }
  function success(data) {
    return { type: eventRefereeConstants.GET_AVAILABLE_REFEREES_SUCCESS, data };
  }
  function failure(error) {
    return {
      type: eventRefereeConstants.GET_AVAILABLE_REFEREES_FAILURE,
      error,
    };
  }
}
